import { Container, Box } from '@mui/material'
import React, { ReactNode } from 'react'

interface PageLayoutProps {
  children: ReactNode
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
}

const PageLayout = ({ children, maxWidth = 'lg' }: PageLayoutProps) => {
  return (
    <Container
      fixed
      maxWidth={maxWidth}
      sx={{
        mb: 1,
        px: { xs: 1, sm: 0 },
        py: 1,
        mx: 0,
      }}>
      <Box>{children}</Box>
    </Container>
  )
}

export default PageLayout